import { EmailAccounts } from '../context'
import { useEmailAccountsProvider } from '../hooks'

function EmailAccountsProvider({ children }) {
  const value = useEmailAccountsProvider()

  return <EmailAccounts value={value}>{children}</EmailAccounts>
}

export default EmailAccountsProvider
